import { render, staticRenderFns } from "./team-form.vue?vue&type=template&id=5c29595e&"
import script from "./team-form.vue?vue&type=script&lang=js&"
export * from "./team-form.vue?vue&type=script&lang=js&"
import style0 from "./team-form.vue?vue&type=style&index=0&id=5c29595e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports